import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import Pl from '../pages/pl/index.vue'/* 评论 */
import PinglunDetail from '../pages/pl/PinglunDetail.vue'/* 评论 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/reference.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import BindCryptoAddress from '../pages/mine/BindCryptoAddress'
import Recharge  from '../pages/mine/Recharge'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import GameDetail  from '../pages/mine/GameDetail'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import MoneyLog  from '../pages/mine/MoneyLog'/* 提现记录 */
import Mymove  from '../pages/mine/Mymove'/* 提现记录 */
import CacheManagement from '../pages/mine/CacheManagement'/* 缓存管理 */






Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'로맨틱'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'로맨틱'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'로맨틱-프로필'}},
	{path:'/Pl',name:'pl',component:Pl,meta:{title:'매니저 후기'}},
	{path:'/PinglunDetail',name:'PinglunDetail',component:PinglunDetail,meta:{title:'매니저 후기'}},
	{path:'/List',name:'list',component:List,meta:{title:'프로필'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'프로필'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'로맨틱-나의'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'비디오'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'게임'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'로그인'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'등록'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'온라인 고객센터'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'온라인 고객센터'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'설치'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'프로파일'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'실명 수정'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'성별 수정'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'결제 비밀번호 관리'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'로그인 암호 관리'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'상세 정보 페이지'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'로맨틱-정보 공지'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'비디오 재생'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'수금 카드를 기입하다'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'수금 카드를 기입하다'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'현금 인출'}},
    {path:'/BindCryptoAddress',name:'BindCryptoAddress',component:BindCryptoAddress,meta:{title:'Bind Withdrawal Address'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'충전'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Personal Report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'현금 인출 기록'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'작업 레코드'}},
    {path:'/GameDetail',name:'GameDetail',component:GameDetail,meta:{title:'작업 상세 정보'}},
    {path:'/MoneyLog',name:'MoneyLog',component:MoneyLog,meta:{title:'잔액 기록'}},
    {path:'/Mymove',name:'Mymove',component:Mymove,meta:{title:'로맨틱-내 영화'}},
    {path:'/CacheManagement',name:'CacheManagement',component:CacheManagement,meta:{title:'Cache Management'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    const titleKeys = {
        login: 'login.doLogin',
        register: 'register.register',
        video: 'video.title',
        mine: 'common.minenav',
        ServiceOnline: 'kefu.title',
        ServicePage: 'kefu.title',
        Setting: 'setting.title',
        Infomation: 'mine.infomation',
        Withdraw: 'withdraw.title',
        Recharge: 'mine.recharge',
        WithdrawRecord: 'mine.withdrawrecord',
        MoneyLog: 'moneylog.title',
        Mymove: 'mine.mymove'
    }
    const titleKey = titleKeys[to.name]
    const pageTitle = titleKey ? i18n.t(titleKey) : ''
    document.title = to.path === '/' || to.path === '/Home' || !pageTitle
        ? 'THE WEKS SELECTIVE'
        : `${pageTitle} - THE WEKS SELECTIVE`
    next()
})

// 在生成路由实例后直接添加这一行：
router.push = (location) => {
    return VueRouter.prototype.push.call(router, location).catch(() => {})
}

export default router
